export default __webpack_public_path__ + "static/media/icons-gpa-2.bee01ccf.png";